<template>
  <div>
    <div :id="containerId" ></div>
  </div>
</template>

<script>
import { Graph } from "@antv/x6";

export default {
  name: "Plate",
  props: {
    containerId: String,
    data: Array,
    graphSize: {
      width: Number,
      height: Number,
    },
    nodeSize: {
      width: Number,
      height: Number,
    },
  },
  watch: {
    data(newValue, oldValue) {
      this.data=newValue
      this.graph.clearCells();
      this.iniNodes();
    },
  },
  data() {
    return {
      graph: null,
      listLocation: new Set(),
      dialogVisible: false,
    };
  },
  mounted() {
    Graph.registerNode(
      "custom-rect",
      {
        inherit: "rect",
        width: this.nodeSize.width,
        height: this.nodeSize.height,
        attrs: {
          body: {
            strokeWidth: 1,
            stroke: "#5F95FF",
            fill: "#EFF4FF",
          },
          text: {
            fontSize: 12,
            fill: "#262626",
          },
        },
      },
      true
    );
    this.graph = this.initGraph();
    this.iniNodes();
  },
  methods: {
    initGraph() {
      const graph = new Graph({
        container: document.getElementById(this.containerId),
        width: this.graphSize.width,
        height: this.graphSize.height,
      });

      graph.on("blank:click", ({ e, x, y, cell, view }) => {
        this.$emit("graphClick");
      });
      graph.on('node:click', ({ e, x, y, node, view }) => {
        //window.open('https://www.baidu.com');
      })
      return graph;
    },
    iniNodes() {
      const list = [];
      this.data.forEach((item) => {
        if (!list.find((i) => i.id === item.id)) {
          const node = this.addNode(item);
          list.push({ id: item.id, node, data: item });
        }
      });
       this.data.forEach((item) => {
         /* if (item.data.target) {
          this.addEdge(
            item.node,
            list.find((i) => i.id === item.data.target).node
          );
        }  */
         if (item.source) {
          this.addEdge(
            list.find((i) => i.id === item.source).node,
            list.find((i) => i.id === item.name).node
          );
        }
      });
    },
    addNode(data) {
      var pos = this.getRandomLocation();
      //var pos = this.getRandomPointWithinRadius(700,200);
      var color = this.getRandomRGBAColor(0.3);
      return this.graph.addNode({
        shape: "custom-rect",
        label: data.name,
        x: pos.x,
        y: pos.y,
        attrs: {
          body: {
            rx: 20,
            ry: 26,
            stroke: color,
            fill: color,
          },
        },
      });
    },
    addEdge(source, target) {
      if(!source||!target) return;
      this.graph.addEdge({
        source: {
          cell: source,
          connectionPoint: "boundary",
        },
        target: {
          cell: target,
          connectionPoint: "boundary",
        },
        attrs: {
          line: {
            stroke: this.getRandomColor(),
            strokeWidth: 0.7,
          },
          lineDash: [4, 4], // 虚线样式
        },
        router: 'metro',
      });
    },
    getRandomLocation() {
      let x, y;
      // 生成随机坐标直到找到未使用的坐标
      do {
        x = Math.floor(Math.random() * this.graphSize.width);
        y = Math.floor(Math.random() * this.graphSize.height);
      } while (this.listLocation.has(`${x},${y}`));

      // 确保坐标在有效范围内
      x = Math.min(x, this.graphSize.width - this.nodeSize.width);
      y = Math.min(y, this.graphSize.height - this.nodeSize.height);
      // 添加新坐标到已生成的坐标集合中
      this.listLocation.add(`${x},${y}`);

      // 返回坐标
      return { x, y };
    },
     getRandomPointWithinRadius(centerX, centerY) {
      const radius = 200;
      const angle = Math.floor(Math.random() * 360);;
      const x = centerX + radius * Math.cos(angle * Math.PI / 180);
      const y = centerY + radius * Math.sin(angle * Math.PI / 180);
      // 返回坐标
      return { x, y };
    },
    getRandomRGBAColor(alpha) {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    getRandomColor() {
      const r = Math.floor(Math.random() * 256);
      const g = Math.floor(Math.random() * 256);
      const b = Math.floor(Math.random() * 256);
      return `rgba(${r}, ${g}, ${b})`;
    },
    click() { },
  },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/Plate/index.vue